exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".overlay .callToAction{padding:.5em}.callToAction>*{font-size:.75em;display:inline-block}.callToAction .action{padding-left:.35em}.callToAction .playButton:before{content:'▶︎ Play Video';white-space:nowrap}", ""]);

